export default __webpack_public_path__ + "static/media/IBMDocumentAdd.a02a9a53.svg";